export const tableOption = {
    border: true,
    index: false,
    stripe: true,
    menu:false,
    align: 'center',
    showClomnuBtn: false,
    searchSize: 'mini',
    refreshBtn: false,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    column: [
      {
        label: '员工号',
        prop: 'unionId',
        overHidden: true,
        fixed: true,
      }, {
        label: 'Birth Name',
        prop: 'realname',
        overHidden: true,
        fixed: true,
      }, {
        label: 'Full Name',
        prop: 'nickname',
        overHidden: true,
        fixed: true,
      }, {
        label: '手机号',
        prop: 'phoneNumber',
        solt: true,
        overHidden: true,
      }, {
        label: 'Position Name',
        prop: 'position',
        overHidden: true,
      }, {
        label: 'Organizational Unit Name',
        prop: 'organizationalUnitName',
        overHidden: true,
      }, {
        label: '课程总积分',
        prop: 'courseRewardValue',
        sortable: 'custom',
        overHidden: true,
      }, {
        label: '课时积分',
        prop: 'coursewareRewardValue',
        sortable: 'custom',
        overHidden: true,
      }, {
        label: '互动积分',
        prop: 'courseInteractiveRewardValue',
        sortable: 'custom',
        overHidden: true,
      }, 
    ]
  }